import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";

import { FormControl, FormGroup } from "@angular/forms";
import { first } from "rxjs/operators";
import { browserRefresh } from "src/app/app.component";
import { ViewImageComponent } from "../view-image/view-image.component";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-area-email-log",
  templateUrl: "./area-email-log.component.html",
  styleUrls: ["./area-email-log.component.scss"],
})
export class AreaEmailLogComponent implements OnInit {
  public gridView: GridDataResult;
  breadCrumbItems: Array<{}>;
  isdropdownShow: boolean;
  isLoading: boolean;

  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();

  searchText: any;
  inputValue: string = "";
  myGroup: FormGroup;
  baseURL: string;
  Type: any;
  UserID: any;
  user: any;

  constructor(
    private datepipe: DatePipe,
    private gs: GeneralService,
    private router: Router,
    private renderer: Renderer2,
    private http: HttpClient,
    public dialog: MatDialog,
    private route: ActivatedRoute
  ) {
    this.Type = this.route.snapshot.params.type;
    if (this.router.getCurrentNavigation()) {
      if (this.router.getCurrentNavigation().extras.state) {
        const state = this.router.getCurrentNavigation().extras.state;
        this.UserID = state["UserId"];
        localStorage.setItem("UserId", this.UserID);
      } else {
        if (localStorage.getItem("UserId")) {
          this.UserID = localStorage.getItem("UserId");
        }
      }
    }
  }

  ngOnInit() {
    this.getusersbyid();
    this.baseURL = this.gs.getBaseurl();
    this.breadCrumbItems = [
      { label: "User Details", path: "/users/users-users-details" },
      { label: "Email for Area-Alert", path: "/", active: true },
    ];
    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      processing: true,
      serverSide: true,
      ordering: false,
      searching: true,
      ajax: (dataTablesParameters: any, callback) => {
        this.http
          .get<DataTablesResponse>(
            `${this.gs.getEmailAlert_data()}` +
              `/${this.UserID}` +
              `?PageNo=${
                (dataTablesParameters.start + dataTablesParameters.length) /
                dataTablesParameters.length
              }` +
              `${
                dataTablesParameters.length.value != ""
                  ? "&PageSize=" + dataTablesParameters.length
                  : ""
              }` +
              `${
                dataTablesParameters.search.value != ""
                  ? "&search=" + dataTablesParameters.search.value
                  : ""
              }`,

            {}
          )
          .subscribe((resp: any) => {
            callback({
              recordsTotal: resp.Count,
              recordsFiltered: resp.Count,
              data: resp.result,
            });
          });
      },
      responsive: true,
      columns: [
        {
          title: "Fullname",
          name: "fullname",
          data: null,
          render: (data) => {
            const maxLength = 15;
            if (data.fullname.length > maxLength) {
              return `<span title="${data.fullname}">${data.fullname.slice(
                0,
                maxLength
              )}...</span>`;
            } else {
              return data.fullname ? data.fullname : "--";
            }
          },
        },
        {
          title: "District",
          name: "district",
          data: null,
          render: (data) => this.renderData(data.district),
        },

        {
          title: "Taluka",
          name: "taluka",
          data: null,
          render: (data) => this.renderData(data.taluka),
        },

        {
          title: "Village",
          name: "village",
          data: null,
          render: (data) => this.renderData(data.village),
        },
        {
          title: "Publish Date",
          name: "publish_date",
          data: null,
          render: (data) => {
            if (
              data.publish_date == "" ||
              data.publish_date == null ||
              data.publish_date == "0000-00-00"
            ) {
              return "N/A";
            } else {
              var date = new Date(data.publish_date);
              return this.datepipe.transform(date, "yyyy-MM-dd");
            }
          },
        },
        {
          title: "Sent Date",
          name: "sent_datetime",
          data: null,
          render: (data) => {
            if (
              data.sent_datetime == "" ||
              data.sent_datetime == null ||
              data.sent_datetime == "0000-00-00 00:00:00"
            ) {
              return "N/A";
            } else {
              var date = new Date(data.sent_datetime);
              return this.datepipe.transform(date, "yyyy-MM-dd");
            }
          },
        },

        {
          title: "Type",
          name: "notice_type",
          data: null,
          render: (data) => {
            return data.notice_type;
          },
        },
        {
          title: "Image",
          name: "image_path",
          orderable: false,
          data: null,
          render: (data, type, row, meta) => {
            return `<div style="display:flex" ><a class="btn text-primary view" title="View Notice">
            <span class="badge badge-success p-1" URL="${this.baseURL}${data.image_path}">View</span></a>`;
          },
        },
      ],
      drawCallback: () => {
        $(".view").on("click", (e) => {
          this.openDialog(e.target.getAttribute("URL"));
        });
      },
    };
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
  getusersbyid() {
    this.isLoading = true;
    this.gs.getusersbyid(this.UserID).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.user = res.data[0];
        this.user.mobileno = this.user.MobileNo.split(",");
        this.user.email = this.user.EmailID.split(",");
        localStorage.setItem("PlanId", this.user.plan);
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
      }
    );
  }
  renderData(data) {
    if (data === "" || data === null || data === "null") {
      return "--";
    } else {
      return data;
    }
  }
  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  openDialog(url): void {
    const dialogRef = this.dialog.open(ViewImageComponent, {
      width: "600px",
      data: { URL: url },
      autoFocus: false,
      maxHeight: "90vh",
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }

  onSearch() {
    this.rerender();
  }

  onchangeSearch() {
    console.log(this.inputValue);
    if (this.inputValue != "") {
      return;
    }
    this.rerender();
  }
  refresh() {
    // may be need to change in this function..
    if (this.myGroup.controls.stateID.value !== 7) {
      this.rerender();
      this.myGroup.controls.stateID.setValue(7);
    }
  }
}
